module.exports = __webpack_public_path__ + "assets/img/statue-1.200825bf.png";